import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Async thunk to fetch customer addresses
export const getCustomerAddress = createAsyncThunk(
  "CustomerAddress/getCustomerAddress",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${baseUrl}delivery-address/api/v1/get/${id}`);
      console.log("customer address",response.data);

      if (response.data.success) {
        return response.data;
      
      } else {
        return rejectWithValue("Failed to fetch addresses");
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getCustomerAddressNew = createAsyncThunk(
  "CustomerAddress/getCustomerAddressNew",
  async (_, { rejectWithValue }) => {
    try {
      const customerId = localStorage.getItem("UserRowId");

      if (!customerId) {
        return rejectWithValue("User not found");
      }

      const url = `${baseUrl}delivery-address/api/v1/list-by-webuser/${customerId}`;
      const response = await axios.post(url, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;

    } catch (error) {
      console.log("❌ ERROR:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

